import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { CodeEditorModule } from '@ngstack/code-editor';
import { Converter } from '@vex/helper/functions/converter';
import { InputControl } from '@vex/utils/input-control';
import { VexModule } from '@vex/vex.module';
import { ToastrModule } from 'ngx-toastr';
import { HttpCancelService } from '../@vex/http-interceptor/http-cancel.service';
import { AuthInterceptor } from '../@vex/http-interceptor/auth.interceptor';
import { DatePipe } from '@angular/common';
import { DateFormatModule } from '@vex/pipes/date-format/date-format.module';
import { PushNotificationsService } from '@vex/services/push-notifications.service';
import { MatSelectModule } from '@angular/material/select';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_RIPPLE_GLOBAL_OPTIONS,
    MatNativeDateModule,
    RippleGlobalOptions
} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '@vex/format/date-formate';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MarkdownModule } from 'ngx-markdown';

import { CookieService } from '@vex/services/cookie.service';
import { SyncStatusPopupComponent } from './sync-status-popup/sync-status-popup.component';

// Microsoft sign-in is handled per-connector by dynamically-constructed MSAL instances
// (login + 2FA), driven by each ActiveDirectory record's own single-tenant app registration.
// There is intentionally no global MSAL instance or app-level Azure AD configuration here.

// Ripple animation repeatedly caused long main-thread stalls on dense cards, menus and
// multi-select screens. Disable it once at the application boundary so every Material
// component uses the same safe interaction behavior.
const globalRippleOptions: RippleGlobalOptions = {
    disabled: true,
    animation: {
        enterDuration: 0,
        exitDuration: 0
    }
};

@NgModule({
    declarations: [AppComponent, SyncStatusPopupComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ToastrModule.forRoot({
            preventDuplicates: true,
            resetTimeoutOnDuplicate: true,
            closeButton: true
        }),
        CustomLayoutModule,
        RouterModule,
        DateFormatModule,
        MatDatepickerModule,
        MatNativeDateModule,
        VexModule,
        // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        MatSelectModule,
        CodeEditorModule.forRoot(),
        MarkdownModule.forRoot()
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleOptions },
        MatDatepickerModule,
        HttpCancelService,
        DatePipe,
        InputControl,
        Converter,
        PushNotificationsService,
        CookieService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
